import styled from 'styled-components'

export const PrintbtnStyle = {
  color: "white",
  background: "#1c93ed !important",
  border: "2px solid rgba(255, 255, 255, 0.5)",
  boxshadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
  borderRadius: "11px",
  width: 100,
  textTransform: "none",
  fontSize: "13px",
  backdropFilter: "blur(10px)",
  height: 40,
  "& .MuiButton-startIcon": {
    margin: "0px",
  },
  "&:hover": {
    border: "2px solid white",
  },
};
export const FormWrapper = styled.div`
  padding: 0 12vw 0 0;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  margin: 30px 0px 0px 10vw;
`;

export const Label = styled.label`
  display: block;
  height: 25px;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  color: black;
`;

export const Inputp = styled.input`
  padding-left: 10px;
  width: 428px;
  height: 35px;
  background: rgba(255, 255, 255, 0);
  border: 2px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 11px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  :focus {
    outline: none;
  }
`;

// const Select = styled.select`
//   width: 428px;
//   height: 40px;
//   background: rgba(255, 255, 255, 0.2);
//   border: 2px solid rgba(255, 255, 255, 0.5);
//   backdrop-filter: blur(10px);
//   border-radius: 11px;
//  color: rgba(0,0,0,0.8);
//  font-size:17px;
//   :focus {
//     outline: none;
//   }
//   Option {
//     height: 40px;
//     background: rgba(255, 255, 255, 0.2);
//     border: 2px solid rgba(255, 255, 255, 0.5);
//     backdrop-filter: blur(10px);
//     border-radius: 11px;
//     color: #000000;
//     :focus {
//       outline: none;
//     }
//   }
// `;

export const LabelDescription = styled.label`
  display: block;
  height: 25px;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: black;
`;
export const InputDescription = styled.textarea`
  padding: 10px;
  width: 420px;
  height: 130px;
  background: rgba(255, 133, 51, 1);
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 11px;
  font-size: 16px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  :focus {
    outline: none;
  }
`;
export const btnStyle = {
  mx: 1,
  color: "white",
  background: "rgba(255,255,255,0.2); !important",
  border: "2px solid rgba(255, 255, 255, 0.5)",
  boxshadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
  borderRadius: "11px",
  backdropFilter: "blur(10px)",
  width: 150,
  textTransform: "none",
  fontSize: "13px",
  "&:hover": {
    border: "2px solid white",
  },
};
export const BoxFieldStyle = {
  "& .MuiOutlinedInput-notchedOutline": {
    fontFamily: "sans-serif",
    border: "2px solid rgba(255, 255, 255, 0.5)",
    borderRadius: "11px",
    // width: "300px",
    height: "40px",
    margin: "none",
    padding: "none",
    textAlign: "center",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
    background: "rgba(255, 133, 51, 1)",
    // boxShadow:'none'
  },
  "& .MuiOutlinedInput-input": {
    position: "relative",
    zIndex: 1,
  },
  "& .MuiInputBase-root ": {
    width: { xs: 300, sm: 443, md: 443, lg: 443, xl: 443 },
    height: "35px",
  },
  "& .MuiFormControl-root": {
    padding: "0px 0px",
    height: "35px",
    color: "white",
  },
  "& .MuiOutlinedInput-root:hover ": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
  "& .MuiSvgIcon-root": {
    zIndex: 2
  },
  "& .MuiButtonBase-root": {
    zIndex: 2
  },
};


export const parseHexColor = (hex) => {
  hex = hex.replace(/^#/, '');
  const bigint = parseInt(hex, 16);
  const r = Math.floor(bigint / 0x10000) % 256;
  const g = Math.floor(bigint / 0x100) % 256;
  const b = bigint % 256;
  return { r, g, b };
};

export const lightenColor = (color, factor) => {
  const newR = Math.min(255, color.r + (255 - color.r) * factor);
  const newG = Math.min(255, color.g + (255 - color.g) * factor);
  const newB = Math.min(255, color.b + (255 - color.b) * factor);
  return formatRGB({ r: newR, g: newG, b: newB });
};

export const formatRGB = (color) => `rgb(${color.r} ${color.g} ${color.b})`;

export const darkenColor = (color, factor) => {
  const newR = color.r * (1 - factor);
  const newG = color.g * (1 - factor);
  const newB = color.b * (1 - factor);
  return formatRGB({ r: newR, g: newG, b: newB });
};

export const generateColorVariants = (baseColor) => {
  const baseColorObj = parseHexColor(baseColor);
  return {
    100: lightenColor(baseColorObj, 0.9),
    200: lightenColor(baseColorObj, 0.8),
    400: lightenColor(baseColorObj, 0.6),
    500: lightenColor(baseColorObj, 0.43),
    700: darkenColor(baseColorObj, 0.1),
    800: darkenColor(baseColorObj, 0.2),
    900: darkenColor(baseColorObj, 0.375),
  };
};

export const getRGBColor = (hex, type) => {
  console.log('type: ', type);
  if (!hex) return;
  const color = generateColorVariants(hex);
  return `--color-${type}-100:${color['100']};
  --color-${type}-200:${color['200']};
  --color-${type}-400:${color['400']};
  --color-${type}-500:${color['500']};
  --color-${type}-600:${hex};
  --color-${type}-700:${color['700']};
  --color-${type}-800:${color['800']};
  --color-${type}-900:${color['900']};
  --tw-ring-color: var(--color-primary);`;
};
